import { Controller } from "@hotwired/stimulus"

// Lets a link from another page land on a given tab through the URL fragment.
export default class extends Controller {
  connect() {
    const hash = window.location.hash
    if (!hash) return

    const link = this.element.querySelector(`[data-toggle="tab"][href="${hash}"]`)
    if (link) $(link).tab("show")
  }
}
